export default "__VITE_ASSET__Bo8J4gn6__"